export const ACTIVE_GROUP_KEY = "activeGroupId";
export const ACTIVE_GROUP_EVENT = "noxus:activeGroupChanged";

export function setActiveGroupId(groupId: string): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(ACTIVE_GROUP_KEY, groupId);
  window.dispatchEvent(
    new CustomEvent<string>(ACTIVE_GROUP_EVENT, { detail: groupId })
  );
}

export function getActiveGroupId(): string {
  if (typeof window === "undefined") return "";
  return sessionStorage.getItem(ACTIVE_GROUP_KEY) ?? "";
}

export function linkedAccountsUrl(groupId: string): string {
  return `/manage-workspace?tab=linked-accounts&groupId=${groupId}`;
}
